import React, { Component, createRef, useRef } from 'react';
import { withRouter, RouteComponentProps, Redirect } from 'react-router-dom';
import styles from './css/Portal.module.css';
import { IonSlide, IonSlides } from '@ionic/react';
import LoremIpsum, { loremIpsum } from 'react-lorem-ipsum';
import screen1 from '../assets/screen1.svg';
import screen2 from '../assets/screen2.svg';

interface WelcomeScreenState {
  // Define the state here
  isMobile: boolean;
}

interface WelcomeScreenProps extends RouteComponentProps {
  // Define the props here
}

class WelcomeScreen extends Component<WelcomeScreenProps, WelcomeScreenState> {
  constructor(props: WelcomeScreenProps) {
    super(props);

    this.state = {
      // Initialize the state here
      isMobile: false,
    };

    this.DoneWelcome = this.DoneWelcome.bind(this);
  }

  componentDidMount() {
    this.checkIsMobile();
    window.addEventListener('resize', this.checkIsMobile);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.checkIsMobile);
  }

  checkIsMobile = () => {
    this.setState({ isMobile: window.innerWidth <= 768 });
  };

  DoneWelcome = () => {
    localStorage.setItem("WelcomeSeen" + localStorage.getItem("id"), "1");
    const { history } = this.props;
    history.push("/Portal");
  }


  render() {
    const { isMobile } = this.state;

    const slidesRef = createRef<HTMLIonSlidesElement>();

    const slideOpts = {
      initialSlide: 0,
      slidesPerView: 1,
      spaceBetween: 10,
      grabCursor: false,
    };

    const value = localStorage.getItem('WelcomeSeen' + localStorage.getItem("id"));
    if (value) {
      return <Redirect to="/Portal" />;
    }

    return (
      <div className={styles.background}>

        <div style={{ height: '5vh' }}></div>
        <div
          className={styles.bigbuttonCases}
          style={{
            height: '90vh',
            display: 'grid',
            gap: '1rem',
            color: 'black',
            overflow: 'hidden',
          }}
        >


          <IonSlides ref={ slidesRef } options={slideOpts} pager={true} style={{ height: '100%', width: '100%' }}>
            <IonSlide>
              <div style={{ height: '90%', width: '100%', overflow: 'auto' }}>
                <p>Welkom bij onze app! Omarm een reis van zelfontdekking en bevorder je mentaal welzijn met boeiende quizzen en gepersonaliseerde inzichten.</p>
                <img src={screen1} alt="Screen 1" style={{ height: '80%', margin: '0 auto' }} />

                <div
                  style={{
                    position: 'absolute',
                    bottom: '20px',
                    right: '20px',
                    width: '30px',
                    height: '30px',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    cursor: 'pointer',
                    borderRadius: '50%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: '#fff',
                  }}
                  onClick={() => {
                    // Add your click event handler here
                    slidesRef.current?.slideNext();
                  }}
                >
                  <span style={{ fontSize: '20px' }}>{'>'}</span>
                </div>
              </div>
            </IonSlide>
            <IonSlide>
              <div style={{ height: '90%', width: '100%', overflow: 'auto' }}>
                <p>Zet een stap richting een gezondere geest! Beantwoord prikkelende quizzen, vergaar waardevol zelfbewustzijn en ontgrendel prestaties om jouw mentaal welzijn te bevorderen.</p>
                <img src={screen2} alt="Screen 2" style={{ height: '70%', margin: '0 auto' }} />
                <button className={styles.button} onClick={this.DoneWelcome}>Ik ben er helemaal klaar voor!</button>
              </div>
            </IonSlide>
          </IonSlides>
        </div>
      </div>
    );
  }
}

export default withRouter(WelcomeScreen);
